import { createContext } from "react";
import { useGetAbTestsQuery } from "src/api/services/abtestsApi";
import { AbTest } from "src/api/types";
import { useProduct } from "../ProductProvider";

export const AbTestContext = createContext<AbTest>({});

const AbTestsProvider = ({ children }: { children: React.ReactNode }) => {
  const productSlug = useProduct((p) => p.slug);
  const { data: abTests = {} } = useGetAbTestsQuery(productSlug);

  return (
    <AbTestContext.Provider value={abTests}>{children}</AbTestContext.Provider>
  );
};

export default AbTestsProvider;
